import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslationService } from '../../services/translation.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from '../../../shared/components/language-selector/language-selector.component';
import { RouterEvent } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SidebarService } from '../../services/sidebar.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        LanguageSelectorComponent
    ],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  isMenuOpen = false;
  isHomePage: boolean = false;
  isLoginPage: boolean = false;
  isLoggedIn$: Observable<boolean>;

  menuItems = [
    { label: 'menu.home', sectionId: 'home' },
    { label: 'menu.about', sectionId: 'company' },
    { label: 'menu.services', sectionId: 'services' },
    { label: 'menu.showcase', sectionId: 'app-showcase' },
    { label: 'menu.contact', sectionId: 'contact' }
  ];

  constructor(
    private router: Router,
    private authService: AuthService,
    private sidebarService: SidebarService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof RouterEvent) {
        this.isHomePage = event.url === '/';
        this.isLoginPage = event.url === '/login';
      }
    });
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  ngOnInit(): void {}

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  scrollToSection(sectionId: string): void {
    if (this.isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Si no estamos en la home, primero navegamos y luego hacemos scroll
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100); // Pequeño delay para asegurar que la vista se ha renderizado
      });
    }
    if (this.isMenuOpen) {
      this.toggleMenu();
    }
  }

  onHamburgerClick(): void {
    if (this.isLoggedIn$ && !this.isHomePage && !this.isLoginPage) {
      this.sidebarService.toggle();
    } else {
      this.toggleMenu();
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleSidebar() {
    this.sidebarService.toggle();
  }
}